import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import Loading from '../../../../components/loading/Loading'
import SelectBox from '../../../../components/form/SelectBox'
import { Link, useParams } from 'react-router-dom'
import { SiteText } from '../../../shared/SiteUrlLink'
import { CHANNEL_ADD_REFERRER } from '../../../channel/add/hooks/useChannelAddReferrer'
import PropTypes from 'prop-types'
import { CampaignTypeBizChannelTypeMap } from '../../../Codes'
import { fetchBizChannels, setBizChannelId } from '../campaignSlice'
import ErrorText from '../../../../components/form/ErrorText'

const from = CHANNEL_ADD_REFERRER.CAMPAIGN

const protocol = {
  HTTPS: 'https://',
  HTTP: 'http://',
}
const getSiteTitle = (name, siteUrl) => {
  const pcSiteText = siteUrl.pcUrl
    ? `${protocol[siteUrl.pcUrl.protocol]}${siteUrl.pcUrl.url}`
    : ''
  const mobileSiteText = siteUrl.mobileUrl
    ? `${protocol[siteUrl.mobileUrl.protocol]}${siteUrl.mobileUrl.url}`
    : ''
  let siteText = pcSiteText
  if (
    pcSiteText !== '' &&
    mobileSiteText !== '' &&
    pcSiteText !== mobileSiteText
  ) {
    siteText = `${pcSiteText}, ${mobileSiteText}`
  } else if (mobileSiteText !== '') {
    siteText = mobileSiteText
  }
  return `${name} (${siteText})`
}

const CampaignBizChannel = ({ modify, error }) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    form: { campaignType, bizChannelId },
    bizChannel: {
      content: bizChannels,
      isLoading: isBizChannelLoading,
      hasError: bizChannelError,
    },
  } = useSelector(state => state.ad.campaign)
  const filteredBizChannels = useMemo(
    () =>
      bizChannels.filter(
        ({ bizChannelType }) =>
          bizChannelType === CampaignTypeBizChannelTypeMap[campaignType]
      ),
    [campaignType, bizChannels]
  )

  useEffect(() => {
    dispatch(fetchBizChannels())
  }, [dispatch, modify])

  const handleChange = useCallback(
    value => dispatch(setBizChannelId(value)),
    [dispatch]
  )
  return (
    <div
      className={classNames('area_item', {
        error,
      })}>
      <strong className="subtit_box">
        비즈채널
        <HelpTooltip>
          광고대상을 의미하며, 캠페인 단위로 비즈채널 선택이 필요합니다.
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        <div className="item_row">
          {isBizChannelLoading ? (
            <Loading />
          ) : filteredBizChannels && filteredBizChannels.length > 0 ? (
            <SelectBox
              placeholder="비즈채널을 선택하세요."
              error={error}
              value={bizChannelId}
              onValueChange={handleChange}
              disabled={modify}
              footer={
                <Link
                  to={`/${adAccountId}/channels/add?from=${from}`}
                  className="link_register">
                  비즈채널 신규 등록하기
                  <span className="img_comm ico_arr" />
                </Link>
              }>
              {filteredBizChannels.map(item => {
                const { id, name, siteUrl } = item
                return (
                  <SelectBox.Item
                    key={id}
                    value={id}
                    text={getSiteTitle(name, siteUrl)}>
                    <span className="limit_line">{name}</span>
                    {siteUrl.pcUrl && (
                      <span className="txt_addr">
                        <SiteText siteUrl={siteUrl.pcUrl} />
                      </span>
                    )}
                    {siteUrl.mobileUrl && (
                      <span className="txt_addr">
                        <SiteText siteUrl={siteUrl.mobileUrl} />
                      </span>
                    )}
                  </SelectBox.Item>
                )
              })}
            </SelectBox>
          ) : (
            <>
              <p className="box_error">
                <span className="ico_comm" />
                {bizChannelError ? (
                  <>
                    일시적인 문제로 비즈채널을 불러올 수 없습니다.
                    <br />
                    페이지를 새로고침 하세요.
                  </>
                ) : (
                  '비즈채널이 없습니다.'
                )}
              </p>
              {bizChannelError === false && (
                <p className="desc_item">
                  광고자산 관리 &gt; 비즈채널 관리에서
                  <Link
                    to={`/${adAccountId}/channels/add?from=${from}`}
                    className="fc_emph">
                    신규 비즈채널을 등록
                  </Link>
                  할 수 있습니다.
                </p>
              )}
            </>
          )}
          <ErrorText error={error} tag="p" />
        </div>
      </div>
    </div>
  )
}
CampaignBizChannel.propTypes = {
  modify: PropTypes.bool.isRequired,
  error: PropTypes.string,
}

export default CampaignBizChannel
